// import React, { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export function AboutUs() {
//   const { pathname } = useLocation();
//   // Scroll to top on route change
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   // Set document title
//   useEffect(() => {
//     document.title = "About Us - Tech Solutions"; // Set page title
//   }, []);

//   return (
//     // <section
//     //   id="about"
//     //   className="relative bg-gray-50 py-12 px-4 sm:px-6 overflow-hidden"
//     //   style={{ minHeight: "calc(100vh - 80px)" }}
//     // >
//     //   {/* Background Circles */}
//     //   <div className="absolute -top-24 -right-24 w-[300px] h-[300px] bg-gradient-to-tr from-blue-400 to-purple-400 rounded-full opacity-15 blur-3xl animate-pulse-slow"></div>
//     //   <div className="absolute -bottom-24 -left-24 w-[250px] h-[250px] bg-gradient-to-tr from-pink-300 to-yellow-300 rounded-full opacity-10 blur-2xl"></div>

//     //   <div className="max-w-4xl mx-auto grid lg:grid-cols-2 gap-8 items-center relative z-10">
//     //     {/* Left Side: About Info */}
//     //     <div className="space-y-3 flex flex-col justify-center">
//     //       <h2 className="text-3xl font-extrabold text-gray-900">
//     //         About <span className="text-blue-600">KevMark Investments</span>
//     //       </h2>
//     //       <p className="text-base">
//     //         At KevMark Investments, we are your trusted partner in technology
//     //         and financial growth. Based in Kampala, Uganda, we specialize in
//     //         providing high-quality computers, accessories, and repair services,
//     //         alongside expert investment solutions to empower individuals and
//     //         businesses.
//     //       </p>
//     //       <p className="text-base">
//     //         Our mission is to deliver innovative tech solutions and strategic
//     //         financial guidance, ensuring our clients thrive in a digital world.
//     //         With a commitment to excellence and customer satisfaction, we
//     //         combine expertise, reliability, and personalized service to meet
//     //         your needs.
//     //       </p>
//     //       <div className="space-y-2 text-gray-700 text-sm">
//     //         <p className="flex items-center gap-2">
//     //           <span className="font-semibold">Founded:</span> 2015
//     //         </p>
//     //         <p className="flex items-center gap-2">
//     //           <span className="font-semibold">Location:</span> Kampala, Uganda
//     //         </p>
//     //         <p className="flex items-center gap-2">
//     //           <span className="font-semibold">Mission:</span> Empowering success
//     //           through technology and investments
//     //         </p>
//     //       </div>
//     //     </div>

//     //     {/* Right Side: Highlight/Image */}
//     //     <div className="bg-white p-6 sm:p-8 rounded-xl shadow-md">
//     //       <h3 className="text-xl font-bold text-gray-900 mb-3">
//     //         Why Choose Us
//     //       </h3>
//     //       <ul className="space-y-2 text-gray-600 text-base">
//     //         <li className="flex items-start gap-2">
//     //           <svg
//     //             className="h-5 w-5 text-blue-600"
//     //             fill="none"
//     //             stroke="currentColor"
//     //             viewBox="0 0 24 24"
//     //             xmlns="http://www.w3.org/2000/svg"
//     //           >
//     //             <path
//     //               strokeLinecap="round"
//     //               strokeLinejoin="round"
//     //               strokeWidth="2"
//     //               d="M5 13l4 4L19 7"
//     //             />
//     //           </svg>
//     //           Expert tech solutions for all your computer needs
//     //         </li>
//     //         <li className="flex items-start gap-2">
//     //           <svg
//     //             className="h-5 w-5 text-blue-600"
//     //             fill="none"
//     //             stroke="currentColor"
//     //             viewBox="0 0 24 24"
//     //             xmlns="http://www.w3.org/2000/svg"
//     //           >
//     //             <path
//     //               strokeLinecap="round"
//     //               strokeLinejoin="round"
//     //               strokeWidth="2"
//     //               d="M5 13l4 4L19 7"
//     //             />
//     //           </svg>
//     //           Tailored investment strategies for financial growth
//     //         </li>
//     //         <li className="flex items-start gap-2">
//     //           <svg
//     //             className="h-5 w-5 text-blue-600"
//     //             fill="none"
//     //             stroke="currentColor"
//     //             viewBox="0 0 24 24"
//     //             xmlns="http://www.w3.org/2000/svg"
//     //           >
//     //             <path
//     //               strokeLinecap="round"
//     //               strokeLinejoin="round"
//     //               strokeWidth="2"
//     //               d="M5 13l4 4L19 7"
//     //             />
//     //           </svg>
//     //           Dedicated customer support with a personal touch
//     //         </li>
//     //       </ul>
//     //     </div>
//     //   </div>
//     // </section>

//     <div>
//       <section
//         id="company-profile"
//         className="py-20 bg-gradient-to-b from-white to-blue-50"
//       >
//         <div className="max-w-7xl mx-auto px-6 lg:px-8">
//           {/* Header */}
//           <div className="text-center mb-16" data-aos="fade-up">
//             <h2 className="text-4xl md:text-5xl font-extrabold text-blue-800 mb-4">
//               Company Profile
//             </h2>
//             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//               Established in 2008, Kevmark Investments Ltd is a leading provider
//               of IT solutions, stationery, and branding services in Uganda.
//             </p>
//           </div>

//           {/* Logo + Intro */}
//           <div
//             className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-center mb-16"
//             data-aos="fade-up"
//             data-aos-delay="100"
//           >
//             <div className="lg:col-span-1 flex justify-center">
//               <img
//                 src="/logo-kevmark.png"
//                 alt="Kevmark Investments Ltd Logo"
//                 className="w-48 h-48 object-contain drop-shadow-lg"
//               />
//             </div>
//             <div className="lg:col-span-2">
//               <h3 className="text-2xl font-bold text-blue-700 mb-3">
//                 About Us
//               </h3>
//               <p className="text-gray-700 leading-relaxed">
//                 Incorporated in Uganda as a limited liability company in{" "}
//                 <strong>2008</strong>, Kevmark Investments Ltd serves corporate
//                 and individual clients in diverse sectors. We offer
//                 international NGOs, government agencies, and private firms a
//                 wide range of high-quality products and services including
//                 computers, printers, toners, stationery, branding, and IT
//                 maintenance.
//               </p>
//               <p className="text-gray-700 mt-4">
//                 Our core business is built on <strong>four pillars</strong>:
//               </p>
//               <ul className="mt-3 space-y-2 text-gray-700">
//                 <li className="flex items-center">
//                   <span className="text-blue-600 mr-2">Check</span>{" "}
//                   <strong>ICT Products, Services & Solutions</strong>
//                 </li>
//                 <li className="flex items-center">
//                   <span className="text-blue-600 mr-2">Check</span>{" "}
//                   <strong>Stationery</strong>
//                 </li>
//                 <li className="flex items-center">
//                   <span className="text-blue-600 mr-2">Check</span>{" "}
//                   <strong>Branding</strong>
//                 </li>
//                 <li className="flex items-center">
//                   <span className="text-blue-600 mr-2">Check</span>{" "}
//                   <strong>Printing</strong>
//                 </li>
//               </ul>
//             </div>
//           </div>

//           {/* Vision, Mission, Core Competencies */}
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
//             {/* Vision */}
//             <div
//               className="bg-white p-8 rounded-2xl shadow-lg border border-blue-100"
//               data-aos="fade-up"
//               data-aos-delay="200"
//             >
//               <h4 className="text-xl font-bold text-blue-700 mb-3">
//                 Our Vision
//               </h4>
//               <p className="text-gray-700">
//                 To be the{" "}
//                 <strong>
//                   leading skills-based IT solutions and stationery provider in
//                   Uganda
//                 </strong>
//                 , delighting our customers.
//               </p>
//             </div>

//             {/* Mission */}
//             <div
//               className="bg-white p-8 rounded-2xl shadow-lg border border-blue-100"
//               data-aos="fade-up"
//               data-aos-delay="300"
//             >
//               <h4 className="text-xl font-bold text-blue-700 mb-3">
//                 Our Mission
//               </h4>
//               <p className="text-gray-700">
//                 Delivering great value through high-caliber professional skills
//                 and services in{" "}
//                 <strong>IT, stationery, branding, and printing</strong>.
//               </p>
//             </div>

//             {/* Core Competencies */}
//             <div
//               className="bg-white p-8 rounded-2xl shadow-lg border border-blue-100"
//               data-aos="fade-up"
//               data-aos-delay="400"
//             >
//               <h4 className="text-xl font-bold text-blue-700 mb-3">
//                 Core Competencies
//               </h4>
//               <ul className="text-gray-700 space-y-2 text-sm">
//                 <li className="flex items-start">
//                   <span className="text-blue-600 mr-2">Circle</span> Opportunity
//                   identification & pursuit
//                 </li>
//                 <li className="flex items-start">
//                   <span className="text-blue-600 mr-2">Circle</span> Account &
//                   project management
//                 </li>
//                 <li className="flex items-start">
//                   <span className="text-blue-600 mr-2">Circle</span> Systems
//                   integration & maintenance
//                 </li>
//                 <li className="flex items-start">
//                   <span className="text-blue-600 mr-2">Circle</span> Sourcing of
//                   complementary products
//                 </li>
//               </ul>
//             </div>
//           </div>

//           {/* Services Grid */}
//           <div className="mb-16" data-aos="fade-up">
//             <h3 className="text-2xl font-bold text-blue-800 mb-8 text-center">
//               Our Services
//             </h3>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl shadow-md">
//                 <h4 className="font-bold text-blue-700 mb-3">
//                   ICT Products, Services & Solutions
//                 </h4>
//                 <ul className="text-gray-700 space-y-2 text-sm">
//                   <li>Preventive Maintenance & Repair</li>
//                   <li>Networking, LAN, VoIP, CCTV</li>
//                   <li>Hardware Supply & Installation</li>
//                   <li>Software Design, Training & Support</li>
//                   <li>Website Design, Hosting & Domains</li>
//                 </ul>
//               </div>
//               <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl shadow-md">
//                 <h4 className="font-bold text-blue-700 mb-3">
//                   Stationery, Branding & Printing
//                 </h4>
//                 <ul className="text-gray-700 space-y-2 text-sm">
//                   <li>Full e-commerce printing platform</li>
//                   <li>Branding: T-shirts, caps, pens, umbrellas</li>
//                   <li>Business cards, flyers, banners</li>
//                   <li>Corporate gifts & promotional items</li>
//                   <li>Fast delivery & competitive pricing</li>
//                 </ul>
//               </div>
//             </div>
//           </div>

//           {/* Brands We Support */}
//           <div className="mb-16" data-aos="fade-up">
//             <h3 className="text-2xl font-bold text-blue-800 mb-8 text-center">
//               Brands We Support
//             </h3>
//             <div className="grid grid-cols-3 md:grid-cols-6 gap-6">
//               {[
//                 "Lenovo",
//                 "Kaspersky",
//                 "Dell",
//                 "HP",
//                 "Microsoft",
//                 "Canon",
//                 "Epson",
//                 "Brother",
//                 "Zebra",
//                 "3M",
//                 "Bic",
//                 "Fellowes",
//               ].map((brand, i) => (
//                 <div
//                   key={i}
//                   className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition-shadow flex items-center justify-center h-24 border border-gray-200"
//                   data-aos="zoom-in"
//                   data-aos-delay={i * 50}
//                 >
//                   <span className="text-gray-600 font-medium text-sm">
//                     {brand}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Org Chart */}
//           <div className="mb-16" data-aos="fade-up">
//             <h3 className="text-2xl font-bold text-blue-800 mb-8 text-center">
//               Organization Structure
//             </h3>
//             <div className="bg-white p-8 rounded-2xl shadow-lg border border-blue-100">
//               <div className="flex flex-col items-center space-y-6">
//                 <div className="bg-blue-700 text-white px-6 py-3 rounded-full font-bold">
//                   Managing Director
//                 </div>
//                 <div className="w-px h-12 bg-blue-300"></div>
//                 <div className="flex gap-8 justify-center">
//                   <div className="text-center">
//                     <div className="bg-blue-600 text-white px-5 py-2 rounded-lg">
//                       General Manager
//                     </div>
//                     <div className="w-px h-8 bg-blue-300 mx-auto mt-2"></div>
//                     <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded mt-2">
//                       Administration Staff
//                     </div>
//                   </div>
//                   <div className="text-center">
//                     <div className="bg-blue-600 text-white px-5 py-2 rounded-lg">
//                       Sales Manager
//                     </div>
//                     <div className="w-px h-8 bg-blue-300 mx-auto mt-2"></div>
//                     <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded mt-2">
//                       Sales Executives
//                     </div>
//                   </div>
//                   <div className="text-center">
//                     <div className="bg-blue-600 text-white px-5 py-2 rounded-lg">
//                       Technical Manager
//                     </div>
//                     <div className="w-px h-8 bg-blue-300 mx-auto mt-2"></div>
//                     <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded mt-2">
//                       Technical Staff
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Corporate Clients */}
//           <div className="mb-16" data-aos="fade-up">
//             <h3 className="text-2xl font-bold text-blue-800 mb-8 text-center">
//               Our Trusted Clients
//             </h3>
//             <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//               {[
//                 "Ministry of Tourism",
//                 "Equity Bank",
//                 "Tropical Bank",
//                 "NUDIPU",
//                 "Kaweri Coffee",
//                 "Kinder Kare School",
//                 "Chapwana World Educatr",
//                 "Chemonics",
//               ].map((client, i) => (
//                 <div
//                   key={i}
//                   className="bg-gray-100 p-6 rounded-xl shadow-sm flex items-center justify-center h-24 text-center text-gray-700 text-sm font-medium"
//                   data-aos="fade-up"
//                   data-aos-delay={i * 50}
//                 >
//                   {client}
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Contact Info */}
//           <div
//             className="bg-blue-700 text-white p-10 rounded-3xl shadow-xl text-center"
//             data-aos="fade-up"
//           >
//             <h3 className="text-2xl font-bold mb-6">Get in Touch</h3>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-lg">
//               <div>
//                 <p className="font-semibold">Main Office</p>
//                 <p>
//                   Plot 59, Nkurumah Road
//                   <br />
//                   Nkrumah Naser Link Plaza
//                 </p>
//               </div>
//               <div>
//                 <p className="font-semibold">Contact</p>
//                 <p>
//                   Tel: (+256) 772 551508
//                   <br />
//                   Email: kevmark2000@gmail.com
//                 </p>
//               </div>
//               <div>
//                 <p className="font-semibold">Sales</p>
//                 <p>
//                   Email: Kevmarksales@gmail.com
//                   <br />
//                   Website: www.kevmarkinvestments.com
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  FaBuilding,
  FaBullseye,
  FaHandshake,
  FaLaptopCode,
  FaPenNib,
  FaPrint,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaUsers,
  FaRegLightbulb,
} from "react-icons/fa";

export function AboutUs() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    document.title = "About Us | Kevmark Investments Ltd";
  }, []);

  return (
    <div className="bg-gradient-to-b from-white to-blue-50 text-gray-800">
      {/* HERO SECTION */}
      <section className="relative py-24 text-center">
        <div className="max-w-6xl mx-auto px-6">
          <h1 className="text-5xl md:text-6xl font-extrabold text-blue-800 mb-4 animate-fadeIn">
            Kevmark Investments Ltd
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto animate-slideUp">
            Empowering Uganda through IT, Stationery, Branding & Printing
            Solutions since 2008.
          </p>
        </div>
      </section>

      {/* COMPANY PROFILE */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div className="flex justify-center">
            <FaBuilding className="text-blue-700 text-[150px] drop-shadow-lg" />
          </div>
          <div>
            <h2 className="text-3xl font-bold text-blue-800 mb-4">
              Company Profile
            </h2>
            <p className="leading-relaxed text-gray-700 mb-3">
              Incorporated in <strong>2008</strong> as a limited liability
              company in Uganda, <strong>Kevmark Investments Ltd</strong> is a
              trusted provider of ICT, Stationery, Branding, and Printing
              solutions for NGOs, government agencies, and private organizations
              across Uganda.
            </p>
            <p className="leading-relaxed text-gray-700">
              We combine innovation, reliability, and professionalism to deliver
              solutions that drive productivity and growth.
            </p>
          </div>
        </div>
      </section>

      {/* VISION & MISSION */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-10">
          {[
            {
              icon: <FaRegLightbulb className="text-blue-700 text-4xl mb-4" />,
              title: "Our Vision",
              text: "To be Uganda’s leading skills-based IT solutions and stationery provider, delighting our customers.",
            },
            {
              icon: <FaBullseye className="text-blue-700 text-4xl mb-4" />,
              title: "Our Mission",
              text: "Delivering great value through high-calibre professional skills and services in IT, stationery, branding, and printing.",
            },
            {
              icon: <FaHandshake className="text-blue-700 text-4xl mb-4" />,
              title: "Core Competencies",
              text: "Opportunity identification, project management, systems integration, and sourcing of complementary products.",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-gradient-to-br from-blue-50 to-white border border-blue-100 rounded-2xl shadow-sm p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 text-center"
            >
              {item.icon}
              <h3 className="text-xl font-bold text-blue-800 mb-2">
                {item.title}
              </h3>
              <p className="text-gray-700 text-sm">{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CORE BUSINESS */}
      <section className="py-20 bg-gradient-to-b from-blue-50 to-white">
        <div className="max-w-6xl mx-auto px-6 text-center mb-12">
          <h2 className="text-3xl font-bold text-blue-800 mb-4">
            Our Core Business
          </h2>
          <p className="text-gray-600">
            Kevmark’s expertise is built on four strong pillars.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto px-6">
          {[
            {
              title: "ICT Solutions",
              icon: <FaLaptopCode className="text-blue-700 text-3xl mb-3" />,
              desc: "Hardware, networking, software, and IT maintenance services.",
            },
            {
              title: "Stationery",
              icon: <FaPenNib className="text-blue-700 text-3xl mb-3" />,
              desc: "Office supplies, scholastic materials, and toners.",
            },
            {
              title: "Branding",
              icon: <FaUsers className="text-blue-700 text-3xl mb-3" />,
              desc: "Creative design, corporate identity, and promotional branding.",
            },
            {
              title: "Printing",
              icon: <FaPrint className="text-blue-700 text-3xl mb-3" />,
              desc: "Digital and offset printing with e-commerce ordering.",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 text-center"
            >
              {item.icon}
              <h4 className="text-lg font-semibold text-blue-700 mb-2">
                {item.title}
              </h4>
              <p className="text-sm text-gray-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* BRANDS SUPPORTED */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 text-center mb-12">
          <h2 className="text-3xl font-bold text-blue-800 mb-4">
            Brands We Support
          </h2>
          <p className="text-gray-600">
            We proudly partner with world-class technology and stationery
            brands.
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4 max-w-6xl mx-auto px-6">
          {[
            "HP",
            "Lenovo",
            "Dell",
            "Canon",
            "Epson",
            "Microsoft",
            "3M",
            "BIC",
            "Kaspersky",
            "Acer",
            "Brother",
            "Zebra",
          ].map((brand, i) => (
            <div
              key={i}
              className="bg-blue-50 border border-blue-100 p-4 rounded-lg shadow-sm flex items-center justify-center text-sm font-medium text-gray-700 hover:bg-blue-100 transition-colors duration-200"
            >
              {brand}
            </div>
          ))}
        </div>
      </section>

      {/* CLIENTS */}
      <section className="py-20 bg-gradient-to-t from-blue-50 to-white">
        <div className="max-w-6xl mx-auto px-6 text-center mb-12">
          <h2 className="text-3xl font-bold text-blue-800 mb-4">
            Our Trusted Clients
          </h2>
          <p className="text-gray-600">
            We proudly serve some of Uganda’s leading organizations.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 max-w-6xl mx-auto px-6">
          {[
            "Ministry of Tourism",
            "Equity Bank",
            "Tropical Bank",
            "NUDIPU",
            "Kaweri Coffee",
            "KinderKare School",
            "Chemonics",
            "UVRI",
          ].map((client, i) => (
            <div
              key={i}
              className="bg-white border border-gray-100 p-6 rounded-xl shadow-sm text-center text-gray-700 text-sm font-medium hover:shadow-md hover:-translate-y-1 transition-all duration-300"
            >
              {client}
            </div>
          ))}
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="py-20 bg-blue-800 text-white text-center">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-8">Get in Touch</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 text-lg">
            <div>
              <FaMapMarkerAlt className="mx-auto text-2xl mb-2" />
              <h4 className="font-semibold mb-2">Main Office</h4>
              <p>
                Office NK003, Nkurumah Naser Link Plaza
                <br />
                Plot 59, Nkurumah Road, Kampala
              </p>
            </div>
            <div>
              <FaPhoneAlt className="mx-auto text-2xl mb-2" />
              <h4 className="font-semibold mb-2">Contact</h4>
              <p>
                Tel: (+256) 772 551508 / 752 551508
                <br />
                P.O. Box 71141, Kampala
              </p>
            </div>
            <div>
              <FaEnvelope className="mx-auto text-2xl mb-2" />
              <h4 className="font-semibold mb-2">Email & Web</h4>
              <p>
                md@kevmarkinvestments.com
                <br />
                sales@kevmarkinvestments.com
                <br />
                <a
                  href="https://www.kevmarkinvestments.com"
                  target="_blank"
                  rel="noreferrer"
                  className="underline text-blue-200 hover:text-white"
                >
                  www.kevmarkinvestments.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
